import { Injectable, OnInit } from '@angular/core';
import { Platform } from '@ionic/angular';
import { Subject } from 'rxjs';
import { LastPlayed } from 'src/app/components/casino-lobby/keywords-casino/models/last-played-model';
import { Navigator } from 'src/app/components/menu/navigator';
import { GeoResponse } from 'src/app/interfaces/geo-interface';
import { CustomerModel } from 'src/app/models/customer-model';
import { ConfigService } from '../config/config.service';
import { EventsService } from '../event/event.service';
import { GameHubControllerService } from '../gameHub/game-hub-controller';
import { JurisdictionService } from '../geo/jurisdiction.service';
import { LobbyStateService } from '../lobbyState/lobby-state.service';
import { UserSessionService } from '../user-session/user-session.service';
import { WebcontentService } from '../webcontent/webcontent.service';
import { WebservicesService } from '../webservices/webservices.service';
import { GamesService } from './games.service';
import { KeywordsService } from './keywords.service';
import { LobbyApiService } from './lobby.api.service';
import { MobileDataService } from '../mobile-data/mobile-data.service';
import { isUndefined } from '../codeUtils';
import { LobbyService } from './lobby.service';
import { AppLinksService } from '../applinks/app-links.service';

@Injectable({
  providedIn: 'root'
})

export class LobbyNavigator implements OnInit {

  private bonusNotificationCount: number = 0;
  private bonusNotificationDisplayedTimesMAX = 3;
  public _recentGamesSubject: Subject<any>;
  public allCasinoGames = [];
  public allLiveDealerSubKeyWords = [];
  public bottomCasinoGames = [];
  public currentTab: any;
  public customer: CustomerModel;
  public emittedObject: {
    action_type?: string,
    keyword?: string,
    gamesInfo?: any,
    subKeywordsInfo?: any,
    lastPlayed?: LastPlayed
  };
  public gamesLastPlayed: any;
  public keywordList: any;
  public bottomKeywordList: any;
  public liveDealerKey: any;
  public lobbyList: any;
  public lobbyName: any;
  public playGameData: any;
  public selectedItem: any;
  public subLiveDealerKeywords: any;
  public isMobileApp: boolean = false;
  public hasLiveDealerSubCategory: boolean = false;

  constructor(
    public config: ConfigService,
    public eventsService: EventsService,
    public gameHubControllerService: GameHubControllerService,
    public gamesService: GamesService,
    public jurisdiction: JurisdictionService,
    public keywordsService: KeywordsService,
    public lobbyStateService: LobbyStateService,
    public navigator: Navigator,
    public userSessionService: UserSessionService,
    public webContentService: WebcontentService,
    public webservicesService: WebservicesService,
    public platform: Platform,
    public appLinksService: AppLinksService,
    public lobbyService: LobbyService,
    private lobbyApiService: LobbyApiService,
    private mobileData: MobileDataService
  ) {
    this.incrementCounter();

    this.userSessionService.getCustomerSubscription().then((customerSubscription) => {
      customerSubscription.subscribe((customer) => this.customer = customer);
    });

    this.gamesService.getGames().subscribe((allgames) => {
      this.allCasinoGames = allgames;
      if (!!allgames[this.selectedItem]) this.emitKeywordandGames();
    });

    this.isMobileApp = this.platform.is("capacitor");

    this.eventsService.subscribe("event:empty:gamedata", () => {
      this.playGameData = null;
    });

    this.eventsService.subscribe("event:select:active:keyword", (data) => {
      this.selectActiveCasinoKeyword(data);
    })
  }

  ngOnInit(): void {
  }

  private verifyAuth(): boolean {
    const sessionToken = this.userSessionService.getSessionToken();
    return sessionToken ? true : false;
  }

  public setAllCasinoGames(data) {
    this.allCasinoGames = data;
  }

  public setKeywordList(list: any) {
    this.keywordList = list;
  }

  public setBottomKeywordList(list: any) {
    this.bottomKeywordList = list;
  }

  public setSelectedItem(data: any) {
    this.selectedItem = data;
  }

  public setCurrentTab(data: any = null) {
    this.currentTab = data;
  }

  public getCurrentTab() {
    return this.currentTab;
  }

  public async getLobbyList() {
    const lobbyFilter: string =
      this.config.getConfig().FEATURE_LOBBYLIST_FILTER ?? "CASINO";

    return new Promise((resolve, reject) => {
      this.keywordsService.getLobbies().subscribe((data: any[]) => {
        // const lobbyTempList = data?.filter((m) => m.name.slice(0, 6).toUpperCase() === lobbyFilter);
        const lobbyTempList = data?.filter(
          (m) => !!~m.name.indexOf(lobbyFilter)
        );
        this.lobbyName = lobbyTempList.filter((l) => {
          if ("placement" in l) {
            return l.placement === "MAIN";
          }
        })[0].name;
        this.lobbyList = lobbyTempList;
        resolve(this.lobbyList);
      });
    });
  }

  public goToLobby(tabname: string) {
    if (this.isMobileApp) {
      this.toKeyTabMobile(tabname);
    } else {
      this.toKeyTab(tabname);
    }
  }

  public toKeyTab(tabname: string) {
    const key: any = this.keywordList?.filter((k) => k.name.toLowerCase() == tabname.toLowerCase());
    this.selectKeyword(key[0]);
  }

  public toKeyTabMobile(tabname: string) {
    const key: any = this.bottomKeywordList?.filter((k) => k.name.toLowerCase() == tabname.toLowerCase());
    setTimeout(() => {
      this.navigator.toCasino();
      if (key[0]) this.mobileData.setMobileLobbyKeyword({ bottomKeyword: key[0].name });
    }, 500);
  }

  //Specific Function which will check keyword_route logic for deeplinks
  public toKeyTabRoute(keywordRoute: string) {
    //Rely on async call to make sure client has casino lobby and keywords list
    this.getLobbyList().then(() => {
      //Added delay to mke sure keywordList has data
      setTimeout(() => {
        const requiredKey = ["keyword_route"];
        //make the filteredArrayWithKeywordRoute to exclude array items list who don't have 'keyword_route' field
        const filteredArrayWithKeywordRoute = this.keywordList.filter(obj => {
          return requiredKey.every(key => Object.keys(obj).includes(key));
        });
        //console.log(filteredArrayWithKeywordRoute);
        //Check filteredArrayWithKeywordRoute list to validate keyword_route and deeplinks which user tries to launch
        if (filteredArrayWithKeywordRoute && filteredArrayWithKeywordRoute.length > 0) {
          const key_route: any = filteredArrayWithKeywordRoute?.filter((k) => k.keyword_route.toLowerCase() == keywordRoute.toLowerCase());
          if (key_route && key_route.length > 0) {
            this.selectKeyword(key_route[0]);
          } else {
            this.toKeyTab('home');
          }
        } else {
          this.toKeyTab('home');
        }
      }, 700);
    })
  }

  public selectKeyword(key: any): any {


    const action = key?.action_type;
    this.selectedItem = key?.name;
    this.selectedKeywordCommonActions(key, this.lobbyName);

    switch (action) {
      case "gamelist":
        const actionParamLD: any = key?.action_param;
        if (!!actionParamLD) return this.internalNavAction(key, actionParamLD);
        this.emitKeywordandGames(key);
        this.eventsService.publish("event:keywordaction");

        if (!isUndefined(key?.keyword_route)) {
          this.navigator.setSelectedCasinoKeyword(key?.keyword_route.toLowerCase())
        } else {
          this.navigator.setSelectedCasinoKeyword('')
        }
        const defaultRoute: any = this.config?.getDeafaultRoute()
        this.gamelistAction(key, defaultRoute);
        break;
      case "externalpageload":
        const stub: string = key.action_param;
        this.webContentService.updateExternalLink(stub);
        this.eventsService.publish("event:reload:externallinks");
        this.emittedObject = {
          keyword: this.selectedItem,
          gamesInfo: null,
        };
        this.lobbyStateService.setCurrentKeywordSubject(this.emittedObject);
        this.navigator.toTab("c", false, stub);
        break;
      case "lastplayed":
        this.onGetLastPlayedGames(this.lobbyName);
        break;
      case "internalnav":
        const actionParam: any = key?.action_param;
        if (!!actionParam) this.internalNavAction(key, actionParam);
        break;
      case "externalLink":
        const externalLink = key?.action_param;
        if(!!externalLink) this.appLinksService.openExternalPage(externalLink);
        break;
    }
  }

  private gamelistAction(key: any, nav: any): void {
    switch (nav) {
      case "/":
        this.navigator.toTab("casino");
        break;
      case "casino":
        if (!isUndefined(key?.keyword_route)) {
          this.navigator.toTab("casino", false, key?.keyword_route);
        } else {
          this.navigator.toTab("casino");
        }
        break;
      case "casino/valley-forge":
        if (!isUndefined(key?.keyword_route)) {
          this.navigator.toTab("casino/valley-forge", false, key?.keyword_route);
        } else {
          this.navigator.toTab("casino/valley-forge");
        }
        break;
      default:
        this.navigator.toTab("casino");
        break;
    }
  }

  private internalNavAction(key: any, nav: any): void {
      
    switch (nav) {
      case 'livedealer':
        this.keywordsService.setLiveDealerSubCategory(false);
        this.liveDealerKey = key;
        const auth: boolean = this.verifyAuth();
        auth ? this.liveDealerLoggedIn() : this.liveDealerLoggedOut(key);
        break;
      case 'subkeyword':
        if (key && key.subKeywords && Object.keys(key?.subKeywords).length !== 0) {
          this.keywordsService.setLiveDealerSubCategory(true);
          this.liveDealerKey = key;
          this.subLiveDealerKeywords = this.liveDealerKey.subKeywords
          const auth: boolean = this.verifyAuth();
          auth ? this.liveDealerLoggedIn() : this.multiLiveDealerLoggedOut(key);
        }
        break;
      case 'RafOverviewComponent':
        this.handleRaf();
        break;
      case 'promotions':
        key.keyword = key.name;
        this.lobbyStateService.setCurrentKeywordSubject(key);
        this.navigator.toPromotions(true);
        break;
      default:
        this.openModal(nav);
        break;
    }

  }

  private openModal(page: string): void {
    this.navigator.navigateTo(page);
  }

  public selectedKeywordCommonActions(key, lobbyName): void {
    this.eventsService.publish("event:game:close");
    this.eventsService.publish("event:balanceState", { show: true });
    this.lobbyStateService.saveActiveKeyword(key, lobbyName);
  }

  public selecHomeIfnotGameList() {
    const filteredArray = this.isMobileApp ? this.bottomKeywordList : this.keywordList;
    const itemSelected: any = filteredArray?.filter((k) => k.name.toLowerCase() == this.selectedItem.toLowerCase())[0];
    if (itemSelected && itemSelected.action_param == "promotions" && itemSelected.action_type == "internalnav") {
      this.navigator.toPromotions();
    } else if (!itemSelected || (itemSelected && itemSelected.action_type !== "gamelist")) {
      this.selectHome()
    } else if (itemSelected && itemSelected.action_param == "livedealer") {
      this.selectHome();
    } else {
      this.selectHome();
      this.navigator.toCasino();
    }
  }

  public selectActiveCasinoKeyword(data?){
    if(this.isMobileApp){
      this.eventsService.publish('event:select:keyword:game:close');
    } else {
      if(this.lobbyService.getCurrentActiveKeywordItem()){
        this.selectKeyword(this.lobbyService.getCurrentActiveKeywordItem());
        let data = this.lobbyService.getCurrentActiveKeywordItem();
        if(data?.action_param === 'livedealer') this.navigator.toLiveDealer();
      } else {
        this.selectHome();
      }
    }
  }

  public selectHome() {
    const obj = {
      action_param: "",
      action_type: "gamelist",
      name: "Home",
    };
    return this.eventsService.publish("searchbar:keyword:click", obj);
  }

  public handleRaf() {
    const auth: boolean = this.verifyAuth();
    if (auth) return this.navigator.navigateTo("RafOverviewComponent", { multipleModals: false }, { navigateBackPage: "default" });
    return this.navigator.navigateTo("LoginComponent", { multipleModals: false });
  }

  public emitKeywordandGames(data?, lastPlayed?) {
    let filteredCasinoGames;
    const keywordLength = !!data && data.keyword_code && data.keyword_code.length;
    if (data && keywordLength > 6 &&
      data.keyword_code.slice(keywordLength - 6, data.keyword_code.length).toUpperCase() === 'BOTTOM' &&
      data.action_param != "livedealer") {
      filteredCasinoGames = this.bottomCasinoGames[this.selectedItem];
    } else {
      filteredCasinoGames = this.allCasinoGames[this.selectedItem];
      if (!filteredCasinoGames && this.isMobileApp) {
        filteredCasinoGames = this.bottomCasinoGames[this.selectedItem];
      }
    }

    this.emittedObject = {
      keyword: this.selectedItem,
      gamesInfo: filteredCasinoGames,
    };

    if (data) {
      this.emittedObject.action_type = data.action_type;
      this.emittedObject.keyword = data.name;
    }

    if (lastPlayed) {
      this.emittedObject.lastPlayed = lastPlayed;
      this.emittedObject.gamesInfo = this.gamesLastPlayed;
    }

    this.lobbyStateService.setCurrentKeywordSubject(this.emittedObject);
  }

  public loadCasinoBottomLobby(lobbyName,  force: boolean = false) {
    this.keywordsService.getKeywordsAndGames(lobbyName, force).then(
      (data) => {
        this.bottomCasinoGames = data[1].payload;
      });
  }

  public onGetLastPlayedGames(lobbyName) {
    let LastPlayedGamesPresent: boolean;
    this.getLastPlayedGames(lobbyName).subscribe((gameIDs) => {

      if (gameIDs.result == 1) {
        this.gamesLastPlayed = gameIDs.payload || '';
        this.gamesLastPlayed.length == 0 ? LastPlayedGamesPresent = false : LastPlayedGamesPresent = true;

        const lastPlayed = {
          isLastPlayed: true,
          LastPlayedGamesPresent: LastPlayedGamesPresent
        }

        this.emitKeywordandGames(null, lastPlayed);
        this.eventsService.publish("event:keywordaction");

      } else {
        console.log("not connected to last played games data");
      }
    });
    this.navigator.toCasino();
  }

  private getLastPlayedGames(lobbyName) {
    this._recentGamesSubject = new Subject<any>();
    this.lobbyApiService.getRecent(lobbyName, true).subscribe((data) => {
      this._recentGamesSubject.next(data);
    });
    return this._recentGamesSubject;
  }

  //Live Dealer//

  public liveDealerLoggedIn(): void {
    this.liveDealerBonusPopover();
  }

  private liveDealerLoggedOut(key) {
    if (this.isMobileApp) {
      this.selectedItem = key.name;
      this.emitKeywordandGames(key);
      this.eventsService.publish("event:keywordaction");
      this.navigator.toTab("casino");
    } else {
      this.currentTab = 'livedealer';
      this.navigateToLiveDealer();
      return this.selectedKeywordCommonActions(this.liveDealerKey, this.lobbyName);
    }
  }

  //seprate function for Multi Live Dealer logic
  private multiLiveDealerLoggedOut(key) {
    //Mobile Apps Remaning to add logic
    if (this.isMobileApp) {
      /*this.selectedItem = key.name;
      this.emitKeywordandGames(key);
      this.eventsService.publish("event:keywordaction");
      this.navigator.toTab("casino");*/
      //this.currentTab = 'livedealer';
      this.navigateToMultiLiveDealer();
      return this.selectedKeywordCommonActions(this.liveDealerKey, this.lobbyName);
    } else {
      //this.currentTab = 'livedealer';
      this.navigateToMultiLiveDealer();
      return this.selectedKeywordCommonActions(this.liveDealerKey, this.lobbyName);
    }
  }

  liveDealerBonusPopover(playGame?: any) {
    this.setFlagToSkipRestrictedBonusPopup();
    if (!!playGame) this.playGameData = playGame;

    const bonusMoneyUseEnabled = this.config.getConfig().EVOLUTION_BONUS_USE_ENABLED ?? 0;

    if (bonusMoneyUseEnabled == "1" && this.bonusNotificationCount <= Number(this.bonusNotificationDisplayedTimesMAX)) {
      !!playGame ? this.createLiveGamePopup() : this.createLiveDealerPopup();
      return this.bonusNotificationCount++;
    }
    return this.liveDealerPopupConfirmCallback();
  }

  setFlagToSkipRestrictedBonusPopup() {
    localStorage.setItem('skipActiveBonusCheck', 'true');
  }

  private popupData: any = {
    title: "Live dealer bonus",
    message: "Using bonus money on live dealer games is restricted. Please note that players cannot currently use bonus funds on any live dealer games.",
    buttonText: "Yes, I understand",
  }

  private createLiveGamePopup() {
    this.popupData.confirm = this.liveGamePopupConfirmCallback;
    this.popupData.decline = this.liveGamePopupDeclineCallback;
    this.openStandardConfirmPopover();
  }

  private createLiveDealerPopup() {
    this.popupData.confirm = this.liveDealerPopupConfirmCallback;
    this.popupData.decline = this.liveDealerPopupDeclineCallback;
    this.openStandardConfirmPopover();
  }

  protected openStandardConfirmPopover() {
    return this.navigator.openPopover(
      "PopoverStandardConfirmComponent",
      { message: this.popupData }, "standard-popover livedealer",
      true, true, true, -1, 'cover', true
    );
  }

  public liveDealerPopupConfirmCallback = (): any => {
    this.navigator.dismissAll();
    return this.loadLiveDealerAfterGeo();
  }

  public liveDealerPopupDeclineCallback = (): any => {
    if(this.lobbyService.getWaitingGameData()) this.lobbyService.clearWaitingGameData();
    this.playGameData = "";
    this.currentTab = null;
    this.incrementCounter(); //Incrementing everytime by one when declining.
    this.navigator.toCasino();
    this.toKeyTab('home');
    return this.navigator.dismissAll();
  }

  public liveGamePopupConfirmCallback = (): any => {
    this.navigator.dismissAll();
    return setTimeout(() => this.gameHubControllerService.launchCasinoGame(this.playGameData), 300);
  }

  public liveGamePopupDeclineCallback = (): any => {
    if(this.lobbyService.getWaitingGameData()) this.lobbyService.clearWaitingGameData();
    this.playGameData = null;
    this.currentTab = null;
    this.incrementCounter(); //Incrementing everytime by one when declining.
    return this.navigator.dismissAll();
  }

  public loadLiveDealerAfterGeo(): any {
    const noLiveDealerGeoCheck: boolean = this.config.getConfig().FEATURE_LIVEDEALER_GEOCHECK_ENABLED ?? true;
    console.log(noLiveDealerGeoCheck)
    if (!noLiveDealerGeoCheck) return this.navigateToLiveDealer();
    return this.jurisdiction.debounceVerifyJurisdiction(() => this.loadLiveDealerAfterGeo()).then((geoResp: GeoResponse) => {
      console.log(geoResp)
      if (geoResp.is_allowed) {
        this.closeGamesBeforeLiveDealer();
        if (this.playGameData) {
          setTimeout(() => this.gameHubControllerService.launchCasinoGame(this.playGameData), 300);
        }
      }
    }).catch(error => {
      console.error("Geo error", error);
      this.toKeyTab('home');
    });
  }

  private closeGamesBeforeLiveDealer() {
    let ldPath: string = '';

    this.keywordsService.getLiveDealerSubCategory().subscribe((data) => {
      if (data) ldPath = 'subcategory';
    })

    this.keywordsService.getLiveDealerFavPath().subscribe((data) => {
      if (data) ldPath = 'fav';
    })

    switch (ldPath) {
      case 'subcategory':
        this.closeGameAndContinue(this.navigateToMultiLiveDealer);
        break;
      case 'fav':
        this.keywordsService.setLiveDealerSubCategory(true);
        this.keywordsService.setLiveDealerFavPath(false);
        this.closeGameAndContinue(this.navigateToMultiLiveDealerFromFav);
        break;
      default:
        this.closeGameAndContinue(this.navigateToLiveDealer);
        break;
    }
  }

  private closeGameAndContinue(navigateFunction: any) {
    const obj: any = {
      customer_id: this.customer.customerId,
      session_token: this.userSessionService.getSessionToken(),
      game_launcher_id: "-1",
    };

    this.webservicesService.post("games/close-game", obj).subscribe(() => {
      navigateFunction.call(this);
    }, () => {
      navigateFunction.call(this);
    });
  };


  public navigateToLiveDealer() {

    this.selectedItem = this.liveDealerKey?.name;

    this.emittedObject = {
      keyword: this.selectedItem,
      gamesInfo: this.allCasinoGames[this.selectedItem],
    };

    this.lobbyStateService.setCurrentKeywordSubject(this.emittedObject);
    this.selectedKeywordCommonActions(this.liveDealerKey, this.lobbyName);
    this.publishliveDealerkeywords(); // only for mobile app
    return this.navigator.toLiveDealer();
  }

  public navigateToMultiLiveDealer() {

    this.selectedItem = this.liveDealerKey?.name;

    this.emittedObject = {
      keyword: this.selectedItem,
      subKeywordsInfo: this.subLiveDealerKeywords,
      gamesInfo: this.allCasinoGames,
    };

    this.lobbyStateService.setCurrentKeywordSubject(this.emittedObject);
    this.selectedKeywordCommonActions(this.liveDealerKey, this.lobbyName);
    this.publishliveDealerkeywords(); // only for mobile app
    return this.navigator.toLiveDealer();
  }

  public navigateToMultiLiveDealerFromFav() {
    this.emittedObject = {
      keyword: this.selectedItem,
      gamesInfo: this.allCasinoGames,
    };
    this.lobbyStateService.setCurrentKeywordSubject(this.emittedObject);
    this.selectedKeywordCommonActions(this.liveDealerKey, this.lobbyName);
    this.publishliveDealerkeywords();
    return this.navigator.toLiveDealer();
  }

  publishliveDealerkeywords() {
    if (this.isMobileApp && this.liveDealerKey) {
      const lobbyKeyword = {
        topKeyword: this.liveDealerKey?.isBottom ? null : this.liveDealerKey.name,
        bottomKeyword: this.liveDealerKey?.isBottom ? this.liveDealerKey.name : null,
      }
      this.mobileData.setMobileLobbyKeyword(lobbyKeyword);
    }
  }

  public navigateToPromotionsWebOrMobile() {
		if(this.isMobileApp) {
			let obj = {
			  action_param: "promotions",
			  action_type: "internalnav",
			  name: "Promotions"
			};
			this.mobileData.sendExternalSelection(obj.name);
      this.navigator.toPromotions();
		} else {
			this.toKeyTab('promotions');
		}
	}

  public incrementCounter() {
    this.bonusNotificationCount = 0;
    this.bonusNotificationDisplayedTimesMAX = this.config.getConfig().EVOLUTION_BONUS_USE_MAX ?? 3;
  }
}
